// extracted by mini-css-extract-plugin
module.exports = {"formItem":"InventoryTransferIn_formItem__qYBS6"};